import React, { useState } from "react";
import Select from "react-select";

const MultiSelectDropdown = ({
    label,
    name,
    options = [], // Pre-provided options
    placeholder = "Select",
    required = false,
    disabled = false,
    needSearch = true,
    onChange,
    value = [],
    ...props
}) => {
    const fieldValue = value || []; // Ensure field value is always an array

    const handleChange = (selectedOptions) => {
        const selectedValues = selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [];

        if (onChange) {
            onChange(selectedValues); // Call the parent onChange with selected values
        }
    };

    return (
        <div className="form-control flex flex-col text-xs">
            {/* Label */}
            {label && (
                <label htmlFor={name} className="font-medium flex items-center text-xs mb-2">
                    {label}
                    {required && <span className="text-red-600 font-bold ml-1 text-xs">*</span>}
                </label>
            )}
            <Select
                options={options}
                value={options.filter((option) => fieldValue.includes(option.value))}
                onChange={handleChange}
                classNamePrefix="react-select"
                className="text-xs"
                placeholder={placeholder}
                isMulti={true}
                isSearchable={needSearch}
                isDisabled={disabled}
                noOptionsMessage={() => "No options available"}
                styles={{
                    control: (base, state) => ({
                        ...base,
                        minHeight: '44px',
                        borderColor: state.isFocused ? '#2563eb' : '#d1d5db',
                        boxShadow: state.isFocused ? '0 0 0 2px rgba(37, 99, 235, 0.1)' : 'none',
                        '&:hover': {
                            borderColor: '#9ca3af'
                        },
                        borderRadius: '8px',
                        transition: 'all 0.2s ease',
                        opacity: disabled ? 0.6 : 1
                    }),
                    menu: (base) => ({
                        ...base,
                        borderRadius: '8px',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #e5e7eb'
                    }),
                    option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected ? '#2563eb' : state.isFocused ? '#f3f4f6' : 'white',
                        color: state.isSelected ? 'white' : '#374151',
                        '&:active': {
                            backgroundColor: '#1d4ed8'
                        }
                    }),
                    multiValue: (base) => ({
                        ...base,
                        backgroundColor: '#e0e7ff',
                        borderRadius: '6px'
                    }),
                    multiValueLabel: (base) => ({
                        ...base,
                        color: '#3730a3',
                        fontWeight: '500'
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        color: '#6366f1',
                        '&:hover': {
                            backgroundColor: '#c7d2fe',
                            color: '#4338ca'
                        }
                    }),
                    placeholder: (base) => ({
                        ...base,
                        color: '#9ca3af'
                    })
                }}
                {...props}
            />
        </div>
    );
};

export default MultiSelectDropdown;
